import React from 'react';
import ContactMe from './ContactMe';
import '../styles/footer.css';
import SocialMedia from '../components/SocialMedia';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('footer');

  return (
    <footer>
      <ContactMe />
      <div className="bl-footer">
        <div className="footer-container">
          <div className="footer-group-left">
            <img alt="website-logo" src="/icons/footer-logo.svg" />
            <p className="footer-copyright-text">{t('copyrightPhrase')}</p>
          </div>
          <div className="footer-group-center">
            <img alt="website-qr-code" src="/icons/footer-qr-logo.svg" />
          </div>
          <div className="footer-group-right">
            <SocialMedia style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
